var map = {
	"./CurrencyResourceDialog": 139,
	"./CurrencyResourceDialog.js": 139,
	"./audio/audio": 415,
	"./audio/audio.js": 415,
	"./close.png": 449,
	"./load/allResource": 926,
	"./load/allResource.js": 926,
	"./load/collection": 927,
	"./load/collection.js": 927,
	"./load/personalResources": 928,
	"./load/personalResources.js": 928,
	"./load/publishResource": 929,
	"./load/publishResource.js": 929,
	"./load/unitResources": 930,
	"./load/unitResources.js": 930,
	"./picture/picture": 169,
	"./picture/picture.js": 169,
	"./video/video": 447,
	"./video/video.js": 447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 771;